import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaychex = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1526 1516",
	width: 1526,
	height: 1516,
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "logo-paychex-svg" }),
		/* @__PURE__ */ _jsx("style", { children: "\n		.s0 { fill: #004b8d } \n	" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Layer",
				fillRule: "evenodd",
				className: "s0",
				d: "m318.1 0.5h751c278.1 0 456.9 155.1 456.9 489 0 306.1-258.3 568.5-655.6 568.5h-313.9l-95.3 457.2h-460.9zm317.8 695.7h174.8c186.8 0 250.4-71.6 250.4-171 0-115.3-103.3-135.1-202.7-135.1h-158.9z"
			})
		})
	]
});
export default SvgPaychex;
